export class TypeToClassBaseValueConverter {
    toView(value) {
        switch(value) {
            case 1: return 'check-box';
            case 2: return 'numeric-up-down text-right';
            case 3: return 'decimal-box text-right';
            case 4: return 'money-box text-right';
            case 5: return 'text-box';
            case 6: return 'html-editor';
            case 7: return 'date-picker';
            case 8: return 'drop-down-list';
            case 10: return 'entity-picker';
            case 11: return 'time-picker';
            case 12: return 'date-time-picker';
            case 13: return 'signature';
            case 18: return 'gps-location';
            case 21: return 'drop-down-list';
            case 22: return 'text-area';
            case 30: return 'check-box';
            case 34: return 'email-address-box';
            case 35: return 'phone-number-box';
            case 36: return 'web-url-box';
            case 37: return 'date-without-year';
            case 38: return 'picture';
            case 39: return 'wiki-text';
            case 40: return 'process-bar';
            case 45: return 'html-box';
            case 46: return 'date-without-day';
            case 48: return 'credit-card-number';
            default: return 'unknown';
        } 
    }
}